<script setup lang="ts">
import { LoaderCircle } from 'lucide';
import { SphIcon } from '@/components/base/icon/index.ts';

defineOptions({ compatConfig: { MODE: 3 } });
defineProps<{ inline?: boolean }>();
</script>

<template>
    <div
        class="loading-wrapper"
        :class="{ inline }"
    >
        <SphIcon :icon="LoaderCircle" class="spinner-icon" />
    </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
.loading-wrapper {
    text-align: center;
    width: 100%;
    font-size: 3em;
    &.inline {
        font-size: 1em;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 100px;
    }
}

.spinner-icon {
    width: 1em;
    height: 1em;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
